module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.6d4940cf.jpg";